import * as React from 'react';
import { NBSP } from '../../../../../../../../../../constants/symbols';
import { UIText2 } from '@cian/ui-kit';
import * as styles from './Service.css';
import { formatNumber } from '../../../../../../../../../../utils/string';

interface IProps {
  title: string;
  count?: number;
  gifted?: boolean;
}

export const Service = (props: IProps) => {
  const { title, count, gifted } = props;

  if (!count) {
    return null;
  }

  return (
    <div className={styles['service']}>
      <UIText2>{title}</UIText2>

      {NBSP}
      <UIText2 data-testid="serviceCount" color="black_60">
        ({formatNumber(count)})
      </UIText2>

      {gifted && (
        <UIText2 data-testid="gifted">
          {NBSP}—{NBSP}в{NBSP}подарок
        </UIText2>
      )}
    </div>
  );
};
